// Form field configurations for different channel types
export const getFormFieldsForChannel = (channelSlug) => {
  switch (channelSlug) {
    case "shopify":
      return [
       /* {
          label: "Store Domain",
          type: "text",
          name: "storeSubDomain",
          placeholder: "Ex: yourstore.myshopify.com",
          value: "",
        },*/
      ];
    case "woocommerce":
      return [
        {
          label: "Store Name",
          type: "text",
          name: "storeName",
          placeholder: "Enter your store name",
          value: "",
        },
        {
          label: "Store Domain",
          type: "text",
          name: "storeUrl",
          placeholder: "Ex. yourstore.com//wordpress",
          value: "",
        },
        {
          label: "Consumer Key",
          type: "text",
          name: "consumerKey",
          placeholder: "Enter your consumer Key",
          value: "",
        },
        {
          label: "Consumer Secrete",
          type: "text",
          name: "consumerSecret",
          placeholder: "Enter consumer secrete",
          value: "",
        },
      ];
    case "amazon":
      return [];
    default:
      return [
        {
          label: "API Key",
          type: "text",
          name: "apiKey",
          placeholder: "Enter your API key",
          value: "",
        },
        {
          label: "API Secret",
          type: "password",
          name: "apiSecret",
          placeholder: "Enter your API secret",
          value: "",
        },
        {
          label: "API URL",
          type: "text",
          name: "apiUrl",
          placeholder: "Enter your API URL",
          value: "",
        },
      ];
  }
};